var whitespaceRegex = /\s/g;
/**
 * A small helper used to prepare a human-friendly font-family to a more API-value
 * @param font {Font} font string to simplify
 * @returns {string} normalized string
 *
 * [1] remove whitespace and set all characters to lowercase
 */

var normalizeFont = function normalizeFont(font) {
  // [1]
  return font.replace(whitespaceRegex, '').toLowerCase();
};

export default normalizeFont;
